module.exports = {"data":{"site":{"siteMetadata":{"title":"Matt Patterson","description":"Matt Patterson is a bright and passionate website and applications developer on the Gold Coast. Always pushing to enhance his learning, he is open to participating in freelance work.","keywords":"web developer, developer, ruby, ruby on rails, php, laravel, melbourne, freelance"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 108
// module chunks = 60335399758886 114276838955818